import type { AppConfig } from './environment.model';

export const environment: AppConfig = {
  production: false,
  apiBaseUrl: 'https://connect.majalengkakab.go.id/api/v1',
  apiCatalogUrl: 'https://apikatalog-dev.kominfomajalengka.dev',
  dbConsoleApiUrl: 'https://dbconsoleapi-dev.kominfomajalengka.dev/api/v1',
  pgAdminUrl: 'https://pgadmin-staging.kominfomajalengka.dev/',
  oauth: {
    issuer: 'https://connect.majalengkakab.go.id',
    clientId: 'db-console',
    redirectUri: 'https://dbconsole-dev.kominfomajalengka.dev/auth/callback',
    scope: 'openid profile email roles',
    tokenEndpoint: 'https://connect.majalengkakab.go.id/oauth2/token',
    authorizeEndpoint: 'https://connect.majalengkakab.go.id/oauth2/authorize',
    userinfoEndpoint: 'https://connect.majalengkakab.go.id/oauth2/userinfo',
  },
};
